import type { FaireProductEntity } from "../../entity_types/product";

export const p_u4mfrqc8ac: FaireProductEntity = {
  token: "p_u4mfrqc8ac",
  type: "product",
  name: "Striped Minimalist Large Capacity Canvas Shoulder Bag",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/7ab7b782aae8f31f2f46221c14293f41b6d54e991702dd01a44183ab467158e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/caeec38a480c1369f81ce397816e2dfbc31ffdd9ea826897f82289b45ed3a356.jpeg",
    "https://cdn.faire.com/fastly/66813f0fc171ae9feab57a88c895500193575c4b87225f2cc69ec05e4966e16e.jpeg",
    "https://cdn.faire.com/fastly/f3e636e21a71c65109b27e0677a1ded27325eda7de34b7d51986730472d1097d.jpeg",
    "https://cdn.faire.com/fastly/a4503819a62c31c1b469e26e4b723a838b8e313b6cdbd37182151077eb4b99a3.jpeg",
    "https://cdn.faire.com/fastly/ebd86dbf85e2a16e239b0b36dc7619c8c7ba27db406ec21fe7c917545cb94af8.jpeg",
    "https://cdn.faire.com/fastly/6659f1c77dee6801666561f47a1104f6876b7c51f197e590eed97c2802dba0e3.jpeg",
    "https://cdn.faire.com/fastly/1dbeca0df6817e49e01edc266d9a90a2c0faa9f58b5a10fb09d036cf9cbfaa21.jpeg",
  ],
  priceDollars: 6.49,
  description:
    "From Kycozy, a brand built on passion and perseverance, we bring you the Striped Minimalist Large Capacity Canvas Shoulder Bag. This tote bag for women stands out with its minimalist design and large capacity, making it an ideal choice for those who value style and functionality. Made with canvas, it's designed to withstand daily wear and tear. Its striped pattern adds a touch of modernity to your look. Enjoy this blend of fashion and utility with Kycozy!",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:35.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
